module.exports = __webpack_public_path__ + "img/egg_inventory.213710e0.svg";